import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Step } from '../../../shared/interfaces/step';

@Component({
    selector: 'app-step-display-final',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step-display-final.component.html',
    styleUrl: './step-display-final.component.scss',
})
export class StepDisplayFinalComponent {
    @Input({ required: true }) public step!: Step;

    public get content(): string | undefined {
        return this.step?.settings?.['content'] as (string | undefined);
    }
}
